import { useMediaDownload } from '@/api/media'
import { DownloadButton } from '@/components/ui/Button'

export default function DownloadTemplateKpiGrd() {
  const { mutate, isLoading } = useMediaDownload()

  const handleDownload = () => {
    mutate({ path: 'template_kpi_grd.xlsx', fileName: 'template_kpi_grd.xlsx' })
  }
  return (
    <div className="flex flex-col gap-1">
      <label htmlFor="download-template-kpi-grd">Download Template KPI GRD</label>
      <DownloadButton id="download-template-kpi-grd" onClick={handleDownload} loading={isLoading}>
        Template KPI GRD
      </DownloadButton>
    </div>
  )
}
